module.exports = __webpack_public_path__ + "static/media/photo191.ed8f6bdb.jpg";